export default function AccountProfileController(
    user, // resolved
    $scope,
    $q,
    Users,
    siteService
) {
    $scope.user = user;

    $scope.siteService = siteService;

    $scope.formHolder = {}; // Obj that can contains the child form (must be passed to form directive ) - used to let button know form state!

    $scope.initPage = () => {
        siteService.getPage(95).then((result) => {
            // if user is allready logged in
            if (result.articleItems[0]) {
                // bool

                $scope.sidebarContent =
                    result.articleItems[0].articleSections[0];
            }
        });
    };

    $scope.initPage();
}
